import * as mapboxgl from "mapbox-gl";
import * as MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { environment } from "../../environments/environment";

export class MapUtils {
  static initializeMap(
    containerId: string,
    lat: number,
    lng: number,
    onLocationSelected: (lngLat: any, placeName: string) => void,
    initialMarkerPosition?: { lng: number; lat: number }
  ) {
    (mapboxgl as any).accessToken = environment.mapbox.accessToken;

    const map = new mapboxgl.Map({
      container: containerId,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: 12,
    });

    const geocoder = new (MapboxGeocoder as any)({
      accessToken: (mapboxgl as any).accessToken,
      mapboxgl: mapboxgl,
      placeholder: "Search for beach location",
      marker: false,
      flyTo: {
        speed: 1.2,
        zoom: 12,
      },
    });

    map.addControl(geocoder, "top-left");
    let marker: mapboxgl.Marker | null = null;

    if (initialMarkerPosition) {
      marker = new mapboxgl.Marker({ draggable: true })
        .setLngLat([initialMarkerPosition.lng, initialMarkerPosition.lat])
        .addTo(map);
    }

    const placeMarker = (lng: number, lat: number) => {
      if (!marker) {
        marker = new mapboxgl.Marker({ draggable: true })
          .setLngLat([lng, lat])
          .addTo(map);
      } else {
        marker.setLngLat([lng, lat]);
      }

      map.flyTo({
        center: [lng, lat],
        zoom: 12,
      });

      reverseGeocode({ lng, lat });
    };

    map.on("click", (e: any) => {
      placeMarker(e.lngLat.lng, e.lngLat.lat);
    });

    geocoder.on("result", (event: any) => {
      const coordinates = event.result.center;
      placeMarker(coordinates[0], coordinates[1]);
      onLocationSelected(coordinates, event.result.place_name);
    });

    const reverseGeocode = (lngLat: any) => {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng},${lngLat.lat}.json?access_token=${environment.mapbox.accessToken}`;
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data.features && data.features.length > 0) {
            onLocationSelected(lngLat, data.features[0].place_name);
          } else {
            onLocationSelected(lngLat, "Location not found");
          }
        })
        .catch((error) => {
          console.error("Error reverse geocoding:", error);
          onLocationSelected(lngLat, "Error retrieving address");
        });
    };

    return {
      map,
      placeMarker,
      destroy: () => {
        if (map) map.remove();
      },
    };
  }
}
